import type { CustomerReservationDetails } from '@iheartjane/data-access';
import { useCallback } from 'react';

import { formatTime, formatWithCalendar } from '@jane/shared/util';

interface ReservationTimeProps {
  reservation: CustomerReservationDetails;
}

export const ReservationTime = ({ reservation }: ReservationTimeProps) => {
  const { reservation_mode, delivery_started_at } = reservation;

  const {
    time_zone_identifier,
    display_delivery_windows_by_day,
    display_pickup_windows_by_day,
  } = reservation.store;

  const formattedDate = useCallback(
    (includeTime: boolean) =>
      formatWithCalendar(
        delivery_started_at,
        time_zone_identifier,
        {
          lastDay: `'Yesterday'${includeTime ? ' h:mm aaa' : ''}`,
          lastWeek: `'Last' EEEE${includeTime ? ' h:mm aaa' : ''}`,
          nextDay: `'Tomorrow'${includeTime ? ' h:mm aaa' : ''}`,
          nextWeek: `'This' EEEE${includeTime ? ' h:mm aaa' : ''}`,
          sameDay: `'Today'${includeTime ? ' h:mm aaa' : ''}`,
          sameElse: `EEE MMM d, yyyy${includeTime ? ' h:mm aaa' : ''}`,
        },
        't'
      ),
    [delivery_started_at, time_zone_identifier]
  );

  const displayDateOnly =
    (reservation_mode === 'delivery' && display_delivery_windows_by_day) ||
    (reservation_mode === 'pickup' && display_pickup_windows_by_day);

  return displayDateOnly ? (
    <span>Scheduled for {formattedDate(false)}</span>
  ) : (
    <span>
      {formattedDate(true)} -{' '}
      {formatTime({
        time: reservation.delivery_finished_at,
        outputFormat: 'h:mm aaa',
        inputFormat: 't',
        timezone: time_zone_identifier,
      })}
    </span>
  );
};
